export default __webpack_public_path__ + "static/media/firebase.6f1a1b33.png";